import { render } from "./MyTracker.vue?vue&type=template&id=56ada832"
import script from "./MyTracker.vue?vue&type=script&lang=js"
export * from "./MyTracker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__